import { ClerkProvider } from '@clerk/clerk-react';
import { useNavigate } from 'react-router-dom';

import TopBar from './components/TopBar';
import Router from './components/Router';
import config from './config';

const clerkPubKey = config.CLERK_PUBLISHABLE_KEY;

function Clerk() {
  const navigate = useNavigate();

  return (
    <ClerkProvider
      appearance={{
        variables: {
          fontFamily: 'Roboto, sans-serif',
        },
      }}
      publishableKey={clerkPubKey}
      navigate={(to) => navigate(to)}
    >
      <TopBar />
      <Router />
    </ClerkProvider>
  );
}

export default Clerk;
